'use client';

import { CircleAlert, CircleCheck, Info, LoaderCircle, X } from 'lucide-react';
import { css, cx } from 'styled-system/css';
import { Flex } from 'styled-system/jsx';

import { IconButton } from '@shaojiang/components/ui/icon-button';
import { Toast } from '@shaojiang/components/ui/toast';

export const toaster = Toast.createToaster({
  placement: 'bottom-end',
  overlap: true,
  gap: 16,
  duration: 5000,
});

const icons = {
  success: CircleCheck,
  error: CircleAlert,
  warning: CircleAlert,
  loading: LoaderCircle,
  info: Info,
} as const;

const iconColor = {
  success: css({ color: 'success.main' }),
  error: css({ color: 'error.main' }),
  warning: css({ color: 'warning.main' }),
  loading: css({ color: 'fg.muted', animation: 'spin' }),
  info: css({ color: 'info.main' }),
} as const;

const iconBase = css({ flexShrink: 0, mt: '0.5' });

export function Toaster() {
  return (
    <Toast.Toaster toaster={toaster}>
      {(toast) => {
        const type = (toast.type ?? 'info') as keyof typeof icons;
        const ToastIcon = icons[type] ?? Info;
        return (
          <Toast.Root key={toast.id}>
            <Flex gap='3' alignItems='flex-start'>
              <ToastIcon className={cx(iconBase, iconColor[type])} size={18} />
              <div>
                <Toast.Title>{toast.title}</Toast.Title>
                <Toast.Description>{toast.description}</Toast.Description>
              </div>
            </Flex>
            <Toast.CloseTrigger asChild>
              <IconButton size='sm' variant='link' aria-label='Close'>
                <X />
              </IconButton>
            </Toast.CloseTrigger>
          </Toast.Root>
        );
      }}
    </Toast.Toaster>
  );
}
